import { Experience } from '@/types'
import React, { useMemo } from 'react'
import { useTranslation } from 'next-i18next'
import {
  getExperiencePriceDisplay,
  getExperiencePriceRange,
} from '@/helper/utils'
import { formatPrice } from '@/helper/formatter'

const ExperienceFromPrice = ({ experience }: { experience: Experience }) => {
  const { t } = useTranslation()

  const fromPrice = useMemo(
    () => getExperiencePriceRange(experience),
    [experience]
  )
  const priceDisplay = useMemo(
    () => getExperiencePriceDisplay(experience, fromPrice),
    [experience, fromPrice]
  )

  if (priceDisplay === 'none') {
    return null
  }

  if (priceDisplay === 'free') {
    return <div className="text-sm">{t('common:free')}</div>
  }

  return (
    <div className="text-sm">
      <span className="font-semibold">
        {t('from_price', { price: formatPrice(fromPrice.min) })}{' '}
      </span>
      <span className="text-xs font-normal">/ {fromPrice.minUnit}</span>
    </div>
  )
}

export default ExperienceFromPrice
